/** Godot island integration copy; keys match across the six supported locales. */
export const islandMessages = {
  zh: {
    dictationTranscribing: '正在转写…',
    dictationPermission: '等待麦克风授权…',
    dictationRecording: '录音中 {seconds} 秒 / 30 秒，点击“结束并转写”。',
    dictationServerHint: '音频上传至 AAJob 自部署识别服务，最多 30 秒；确认文字后发送。',
    dictationPermissionTimeout: '未能打开麦克风，请检查浏览器和系统麦克风权限后重试。',
    dictationNoSpeech: '没有识别到语音，请靠近麦克风重试；草稿已保留。',
    dictationTooLong: '录音超过 30 秒，请说短一些后重试。',
    dictationInvalidAudio: '无法读取录音，请重录；草稿已保留。',
    dictationBusy: '语音服务忙，请稍后重试；草稿已保留。',
    dictationServerError: '转写失败，请重试；草稿已保留。',
    httpError: '服务暂时返回了异常响应（HTTP {status}），请稍后重试；草稿已保留。',
    message: '说点什么…',
    closeHint: 'E 收起对话；输入文字时按 Esc 收起',
    dictationStart: '开始录音',
    dictationStop: '结束并转写',
    dictationUnavailable: '此浏览器不支持语音录入，请用文字输入。',
    dictationError: '录音失败（{code}）。请检查麦克风权限；草稿已保留。',
    title: '小岛对话', enter: '走进小岛', agent: '绑定 Agent', voiceOn: '语音已开启', voiceOff: '开启语音',
    voiceReady: '语音已开启。点击小人，和你的 Agent 聊聊吧。', voiceUnavailable: '此浏览器没有可用的语音合成，文字对话仍可使用。',
    speechError: '语音播放失败（{code}），可以重新开启语音；回复文字仍保留在下方。', protocolError: '小岛连接消息无效，请刷新重试。',
    connected: '已连接 {name}', loading: '正在连接 {name}…',
    instructions: '点击头顶有 Agent 名字的小人，或靠近后按 E 对话。WASD 行走；鼠标捕获不可用时，按住左键拖动转头。',
    private: '复用你与这个 Agent 的私聊', back: '返回小岛',
  },
  en: {
    dictationTranscribing: 'Transcribing…',
    dictationPermission: 'Waiting for microphone permission…',
    dictationRecording: 'Recording {seconds}s / 30s. Click Stop and transcribe.',
    dictationServerHint: 'Audio goes to AAJob’s self-hosted recognition service, up to 30 seconds. Review text before sending.',
    dictationPermissionTimeout: 'Could not open the microphone. Check browser and system microphone permissions and retry.',
    dictationNoSpeech: 'No speech recognized. Move closer to the microphone and retry. Your draft is preserved.',
    dictationTooLong: 'Audio exceeds 30 seconds. Please record a shorter message.',
    dictationInvalidAudio: 'Could not read this recording. Please record again. Your draft is preserved.',
    dictationBusy: 'Speech service is busy. Retry shortly. Your draft is preserved.',
    dictationServerError: 'Transcription failed. Please retry. Your draft is preserved.',
    httpError: 'The service returned an unexpected response (HTTP {status}). Please retry later; your draft is preserved.',
    message: 'Say something…',
    closeHint: 'E closes chat; while typing, press Esc',
    dictationStart: 'Speak',
    dictationStop: 'Stop and transcribe',
    dictationUnavailable: 'Voice input is unavailable in this browser. Please type instead.',
    dictationError: 'Voice input failed ({code}). Check microphone access and the recognition service. Your draft is preserved.',
    title: 'Island chat', enter: 'Enter the island', agent: 'Linked Agent', voiceOn: 'Voice on', voiceOff: 'Enable voice',
    voiceReady: 'Voice is on. Click your Agent’s character to chat.', voiceUnavailable: 'Speech synthesis is unavailable in this browser. Text chat still works.',
    speechError: 'Speech failed ({code}). Enable voice again to retry; the reply remains below.', protocolError: 'Invalid island connection message. Refresh to retry.',
    connected: 'Connected to {name}', loading: 'Connecting to {name}…',
    instructions: 'Click the character named after your Agent, or approach and press E. WASD to walk; hold the left mouse button to look if pointer lock is unavailable.',
    private: 'Your existing private chat with this Agent', back: 'Back to island',
  },
  ja: {
    dictationTranscribing: '文字起こし中…',
    dictationPermission: 'マイクの許可を待っています…',
    dictationRecording: '録音中 {seconds} 秒 / 30 秒。終了ボタンで文字にします。',
    dictationServerHint: '最大30秒の音声をAAJobの自前認識サービスへ送信します。文字を確認して送信してください。',
    dictationPermissionTimeout: 'マイクを開けません。ブラウザーとシステムのマイク権限を確認してください。',
    dictationNoSpeech: '音声を認識できません。マイクに近づいて再試行してください。下書きは保持されています。',
    dictationTooLong: '録音が30秒を超えました。短く録音してください。',
    dictationInvalidAudio: '録音を読み取れません。再録音してください。下書きは保持されています。',
    dictationBusy: '音声サービスは処理中です。少し待って再試行してください。下書きは保持されています。',
    dictationServerError: '文字起こしに失敗しました。再試行してください。下書きは保持されています。',
    httpError: 'サービスの応答が異常です（HTTP {status}）。後ほど再試行してください。下書きは保持されています。',
    message: 'メッセージを入力…',
    closeHint: 'E で閉じる。入力中は Esc',
    dictationStart: '音声入力',
    dictationStop: '入力を終了',
    dictationUnavailable: 'このブラウザーは音声入力に対応していません。文字で入力してください。',
    dictationError: '音声入力に失敗しました（{code}）。マイク権限と認識サービスを確認してください。入力済みの文字は保持されます。',
    title: '島で対話', enter: '島に入る', agent: '連携 Agent', voiceOn: '音声オン', voiceOff: '音声を有効にする',
    voiceReady: '音声を有効にしました。Agent のキャラクターをクリックして対話してください。', voiceUnavailable: 'このブラウザーでは音声合成を利用できません。文字での対話は可能です。',
    speechError: '音声再生に失敗しました（{code}）。音声を再度有効にしてください。返信の文字は下に残ります。', protocolError: '島の接続メッセージが無効です。再読み込みしてください。',
    connected: '{name} に接続済み', loading: '{name} に接続中…',
    instructions: 'Agent 名のキャラクターをクリックするか、近づいて E キーで対話します。WASD で移動。マウスを固定できない場合は左ボタンを押しながら視点を動かします。',
    private: 'この Agent との既存のプライベート対話', back: '島に戻る',
  },
  es: {
    dictationTranscribing: 'Transcribiendo…',
    dictationPermission: 'Esperando permiso del micrófono…',
    dictationRecording: 'Grabando {seconds}s / 30s. Pulsa Terminar y transcribir.',
    dictationServerHint: 'El audio se envía al servicio propio de AAJob, hasta 30 segundos. Revisa el texto antes de enviarlo.',
    dictationPermissionTimeout: 'No se pudo abrir el micrófono. Revisa los permisos del navegador y del sistema.',
    dictationNoSpeech: 'No se reconoció voz. Acércate al micrófono y reintenta. Se conserva el borrador.',
    dictationTooLong: 'El audio supera 30 segundos. Graba un mensaje más corto.',
    dictationInvalidAudio: 'No se pudo leer la grabación. Graba de nuevo. Se conserva el borrador.',
    dictationBusy: 'El servicio está ocupado. Reintenta luego. Se conserva el borrador.',
    dictationServerError: 'Falló la transcripción. Reintenta. Se conserva el borrador.',
    httpError: 'El servicio devolvió una respuesta inesperada (HTTP {status}). Reintenta más tarde; se conserva el borrador.',
    message: 'Escribe un mensaje…',
    closeHint: 'E cierra el chat; al escribir, pulsa Esc',
    dictationStart: 'Hablar',
    dictationStop: 'Detener micro',
    dictationUnavailable: 'Este navegador no admite entrada de voz. Escribe el mensaje.',
    dictationError: 'Falló la entrada de voz ({code}). Revisa el micrófono y el servicio de reconocimiento. Se conserva el borrador.',
    title: 'Charla en la isla', enter: 'Entrar en la isla', agent: 'Agent vinculado', voiceOn: 'Voz activada', voiceOff: 'Activar voz',
    voiceReady: 'La voz está activada. Haz clic en tu Agent para conversar.', voiceUnavailable: 'Este navegador no ofrece síntesis de voz. El chat de texto sigue disponible.',
    speechError: 'Falló la voz ({code}). Vuelve a activarla; el texto permanece abajo.', protocolError: 'Mensaje de conexión no válido. Recarga la página.',
    connected: 'Conectado a {name}', loading: 'Conectando a {name}…',
    instructions: 'Haz clic en el personaje con el nombre de tu Agent, o acércate y pulsa E. WASD para caminar; mantén pulsado el botón izquierdo para mirar si el bloqueo del ratón no está disponible.',
    private: 'Tu conversación privada existente con este Agent', back: 'Volver a la isla',
  },
  id: {
    dictationTranscribing: 'Mentranskripsikan…',
    dictationPermission: 'Menunggu izin mikrofon…',
    dictationRecording: 'Merekam {seconds} dtk / 30 dtk. Klik Selesai dan transkripsikan.',
    dictationServerHint: 'Audio dikirim ke layanan pengenal milik AAJob, maksimal 30 detik. Periksa teks sebelum mengirim.',
    dictationPermissionTimeout: 'Mikrofon tidak dapat dibuka. Periksa izin mikrofon di browser dan sistem.',
    dictationNoSpeech: 'Ucapan tidak dikenali. Dekati mikrofon dan coba lagi. Draf tetap tersimpan.',
    dictationTooLong: 'Audio lebih dari 30 detik. Rekam pesan yang lebih pendek.',
    dictationInvalidAudio: 'Rekaman tidak dapat dibaca. Rekam ulang. Draf tetap tersimpan.',
    dictationBusy: 'Layanan sedang sibuk. Coba sesaat lagi. Draf tetap tersimpan.',
    dictationServerError: 'Transkripsi gagal. Coba lagi. Draf tetap tersimpan.',
    httpError: 'Respons layanan tidak sesuai (HTTP {status}). Coba lagi nanti; draf tetap disimpan.',
    message: 'Tulis pesan…',
    closeHint: 'E menutup obrolan; saat mengetik, tekan Esc',
    dictationStart: 'Bicara',
    dictationStop: 'Hentikan mikrofon',
    dictationUnavailable: 'Input suara tidak tersedia di browser ini. Silakan ketik.',
    dictationError: 'Input suara gagal ({code}). Periksa izin mikrofon dan layanan pengenalan. Draf tetap disimpan.',
    title: 'Obrolan pulau', enter: 'Masuk ke pulau', agent: 'Agent terhubung', voiceOn: 'Suara aktif', voiceOff: 'Aktifkan suara',
    voiceReady: 'Suara aktif. Klik karakter Agent untuk mengobrol.', voiceUnavailable: 'Sintesis suara tidak tersedia di browser ini. Obrolan teks tetap berfungsi.',
    speechError: 'Suara gagal ({code}). Aktifkan kembali; teks balasan tetap ditampilkan.', protocolError: 'Pesan koneksi pulau tidak valid. Muat ulang halaman.',
    connected: 'Terhubung ke {name}', loading: 'Menghubungkan ke {name}…',
    instructions: 'Klik karakter bernama Agent Anda, atau dekati dan tekan E. WASD untuk berjalan; tahan tombol kiri untuk melihat jika penguncian mouse tidak tersedia.',
    private: 'Percakapan pribadi Anda yang sudah ada dengan Agent ini', back: 'Kembali ke pulau',
  },
  pt: {
    dictationTranscribing: 'Transcrevendo…',
    dictationPermission: 'Aguardando permissão do microfone…',
    dictationRecording: 'Gravando {seconds}s / 30s. Clique em Parar e transcrever.',
    dictationServerHint: 'O áudio vai para o serviço próprio da AAJob, até 30 segundos. Confira o texto antes de enviar.',
    dictationPermissionTimeout: 'Não foi possível abrir o microfone. Confira as permissões do navegador e do sistema.',
    dictationNoSpeech: 'Nenhuma fala reconhecida. Aproxime-se do microfone e tente novamente. Rascunho preservado.',
    dictationTooLong: 'O áudio supera 30 segundos. Grave uma mensagem mais curta.',
    dictationInvalidAudio: 'Não foi possível ler a gravação. Grave novamente. Rascunho preservado.',
    dictationBusy: 'Serviço ocupado. Tente em instantes. Rascunho preservado.',
    dictationServerError: 'Falha na transcrição. Tente novamente. Rascunho preservado.',
    httpError: 'O serviço retornou uma resposta inesperada (HTTP {status}). Tente novamente mais tarde; o rascunho foi preservado.',
    message: 'Escreva uma mensagem…',
    closeHint: 'E fecha a conversa; ao digitar, pressione Esc',
    dictationStart: 'Falar',
    dictationStop: 'Parar microfone',
    dictationUnavailable: 'Este navegador não oferece entrada de voz. Digite a mensagem.',
    dictationError: 'Falha na entrada de voz ({code}). Verifique o microfone e o serviço de reconhecimento. O rascunho foi preservado.',
    title: 'Conversa na ilha', enter: 'Entrar na ilha', agent: 'Agent vinculado', voiceOn: 'Voz ativada', voiceOff: 'Ativar voz',
    voiceReady: 'Voz ativada. Clique no personagem do seu Agent para conversar.', voiceUnavailable: 'A síntese de voz não está disponível neste navegador. A conversa por texto continua disponível.',
    speechError: 'Falha na voz ({code}). Ative-a novamente; a resposta permanece abaixo.', protocolError: 'Mensagem de conexão inválida. Recarregue a página.',
    connected: 'Conectado a {name}', loading: 'Conectando a {name}…',
    instructions: 'Clique no personagem com o nome do seu Agent, ou aproxime-se e pressione E. WASD para andar; segure o botão esquerdo para olhar se o bloqueio do mouse não estiver disponível.',
    private: 'Sua conversa privada existente com este Agent', back: 'Voltar à ilha',
  },
}
